import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';

const ANCHOR_HOVERED = css`
  :hover {
    color: ${props => props.theme.hover};
    text-decoration: underline;
  }
`;

const ANCHOR_FOCUSED = css`
  :focus {
    outline: none;
    color: ${props => props.theme.focused};
    text-decoration: underline;
  }
`;

const ANCHOR_ACTIVE = css`
  :active {
    color: ${props => props.theme.pressed};
    & svg {
      * {
        fill: ${props => props.theme.pressed};
      }
    }
  }
`;

const ANCHOR_DISABLED = css`
  color: ${props => props.disabled && props.theme.disabled};
  & svg {
    * {
      fill: ${props => props.disabled && props.theme.disabled};
    }
  }
  pointer-events: ${props => props.disabled ? 'none' : ''};
`;

export default {
  Anchor: styled.a`
    ${Tokens.TYPOGRAPHY.BODY}
    display: inline-block;
    color: ${props => props.theme.normal};
    text-decoration: none;
    & svg {
      * {
        fill: ${props => props.theme.normal};
      }
    }
    ${ANCHOR_HOVERED}
    ${ANCHOR_FOCUSED}
    ${ANCHOR_ACTIVE}
    ${ANCHOR_DISABLED}
  `,

  ContentWrapper: styled.span`
    display: flex;
    justify-content: end;
    align-items: center;
    overflow: hidden;
    & > * {
      margin-left: ${props => (props.RTL || props.$rtl || props.rtl) ? Tokens.SPACING.SPACING_0 : Tokens.SPACING.SPACING_4};
      margin-right: ${props => (props.RTL || props.$rtl || props.rtl) ? Tokens.SPACING.SPACING_4 : Tokens.SPACING.SPACING_0};
    }
    ${({ $rtl }) => $rtl && css`
      direction: rtl;
    `}
  `,
};